import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {
  /*-------------------------------------------------------------------------------
    ページ初期化: ロード処理
  --------------------------------------------------------------------------------*/
  pageLoading();
  modalImage();
  const mobileView = window.matchMedia('(max-width: 900px)');


  /*-------------------------------------------------------------------------------
    フッター: キャラクタースクロール演出
  --------------------------------------------------------------------------------*/
  const footer = document.querySelector('.footer');
  const footerBottom = footer?.querySelector('.ft_bottom');
  const footerFigure = document.querySelector('.ft_figure');
  const footerCharacter02 = footerFigure?.querySelector('.ft_figure_chara--02');
  const footerCharacter01 = footerFigure?.querySelector('.ft_figure_chara--01');
  const footerCaption = footerFigure?.querySelector('figcaption');
  const footerTrigger = mobileView.matches ? (footerBottom || footer) : (footerFigure || footer);

  if (footerTrigger && footerCharacter02 && footerCharacter01) {
    const revealTargets = footerCaption
      ? [footerCharacter02, footerCharacter01, footerCaption]
      : [footerCharacter02, footerCharacter01];

    gsap.set(revealTargets, {
      autoAlpha: 0,
      y: 36,
    });

    const footerTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: footerTrigger,
        start: 'top 70%',
        once: true,
      },
    })
      .to(footerCharacter02, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "back.out(5)",
      })
      .to(footerCharacter01, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "back.out(5)",
      });

    if (footerCaption) {
      footerTimeline.to(footerCaption, {
        autoAlpha: 1,
        y: 0,
        duration: 0.4,
        ease: "back.out(5)",
      });
    }
  }


  /*-------------------------------------------------------------------------------
    index opening: opening_block 演出
  --------------------------------------------------------------------------------*/
  const openingStorageKey = 'lal:index-opening-played';
  const playOpeningEveryLoad = false;

  const shouldPlayIndexOpening = () => {
    if (playOpeningEveryLoad) {
      return true;
    }

    try {
      return window.localStorage.getItem(openingStorageKey) !== '1';
    } catch (error) {
      return true;
    }
  };

  const markIndexOpeningPlayed = () => {
    try {
      window.localStorage.setItem(openingStorageKey, '1');
    } catch (error) {
      // localStorage が使えない環境では毎回再生
    }
  };

  const isIndexPage = document.body.classList.contains('home') || document.body.classList.contains('front-page');
  const openingBlock = document.querySelector('.opening_block');
  const mvSection = document.querySelector('.mv_sec');
  const copyBlock = mvSection?.querySelector('.copy_block');
  const sourceMvCopy = copyBlock?.querySelector('.mv_copy');
  const sourceMvEnCopy = copyBlock?.querySelector('.mv_en_copy');
  const openingImages = [
    document.querySelector('.mv_img--01'),
    document.querySelector('.mv_img--02'),
    document.querySelector('.mv_img--03'),
    document.querySelector('.mv_img--04'),
  ].filter(Boolean);

  if (isIndexPage && openingBlock && sourceMvCopy && sourceMvEnCopy && openingImages.length) {
    const openingMvCopy = sourceMvCopy.cloneNode(true);
    const openingMvEnCopy = sourceMvEnCopy.cloneNode(true);
    openingMvCopy.classList.add('is_opening');
    openingMvEnCopy.classList.add('is_opening');

    openingMvCopy.style.opacity = '0';
    openingMvCopy.style.visibility = 'hidden';
    openingMvEnCopy.style.opacity = '0';
    openingMvEnCopy.style.visibility = 'hidden';

    openingBlock.innerHTML = '';
    openingBlock.appendChild(openingMvCopy);
    openingBlock.appendChild(openingMvEnCopy);

    gsap.set(openingBlock, {
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      rowGap: 12,
      backgroundColor: '#fff',
      zIndex: 50,
      pointerEvents: 'none',
    });

    if (!shouldPlayIndexOpening()) {
      gsap.set(openingBlock, { display: 'none' });
    } else {
      const runIndexOpeningAnimation = () => {
        const openingDurationScale = 1.3;
        const d = (value) => value * openingDurationScale;

        gsap.set([openingMvCopy, openingMvEnCopy], {
          autoAlpha: 0,
          y: 22,
        });

        gsap.set(openingImages, {
          autoAlpha: 0,
          y: 24,
        });

        gsap.timeline({
          defaults: {
            ease: 'power2.out',
          },
        })
          .to(openingMvCopy, {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          })
          .to(openingMvEnCopy, {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          },`-=0.6`)
          .to([openingMvCopy, openingMvEnCopy, openingBlock], {
            autoAlpha: 0,
            duration: d(1),
          },`+=${d(0.5)}`)
          .add(() => {
            gsap.set(openingBlock, {
              display: 'none',
              autoAlpha: 1,
            });
          }, `-=${d(0.8)}`)
          .to(openingImages[0], {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          }, `-=${d(0.8)}`)
          .to(openingImages[1], {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          }, `-=${d(0.8)}`)
          .to(openingImages[2], {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          }, `-=${d(0.8)}`)
          .to(openingImages[3], {
            autoAlpha: 1,
            y: 0,
            duration: d(0.9),
          }, `-=${d(0.8)}`)
          .add(() => {
            markIndexOpeningPlayed();
            ScrollTrigger.refresh();
          });
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(runIndexOpeningAnimation).catch(runIndexOpeningAnimation);
      } else {
        runIndexOpeningAnimation();
      }
    }
  }

  /*-------------------------------------------------------------------------------
    index intro: キャラクター＆キャプション表示アニメーション
  --------------------------------------------------------------------------------*/
  const introDecBlock = document.querySelector('.intro_dec_block');
  const introChara02 = introDecBlock?.querySelector('.intro_figure_chara--02');
  const introChara01 = introDecBlock?.querySelector('.intro_figure_chara--01');
  const introFigureCaption = introDecBlock?.querySelector('figcaption');

  if (introDecBlock && introChara02 && introChara01 && introFigureCaption) {
    gsap.set([introChara02, introChara01], {
      autoAlpha: 0,
      y: 46,
    });

    gsap.set(introFigureCaption, {
      autoAlpha: 0,
      y: 24,
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: introDecBlock,
        start: 'top 70%',
        once: true,
      },
    })
      .to(introChara02, {
        autoAlpha: 1,
        y: 0,
        duration: 0.72,
        ease: 'back.out(3.4)',
      })
      .to(introChara01, {
        autoAlpha: 1,
        y: 0,
        duration: 0.72,
        ease: 'back.out(3.4)',
      }, '-=0.5')
      .to(introFigureCaption, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
      }, '-=0.5');
  }

  const indexIntroSection = document.querySelector('.photo-scatter');
  const introLeadBlock = document.querySelector('.intro_lead_block');
  const introLeadPinStart = mobileView.matches ? 'top 0%' : 'top 0%';
  const introLeadPinEnd = mobileView.matches ? 'bottom bottom' : 'bottom 80%';

  if (indexIntroSection && introLeadBlock) {
    gsap.timeline({
      scrollTrigger: {
        trigger: introLeadBlock,
        start: introLeadPinStart,
        endTrigger: indexIntroSection,
        end: introLeadPinEnd,
        pin: introLeadBlock,
        invalidateOnRefresh: true,
      },
    });
  }


  /*-------------------------------------------------------------------------------
    earthquake-proof: 順番表示アニメーション
  --------------------------------------------------------------------------------*/
  const eqProofFlowTracks = Array.from(document.querySelectorAll('.common_flow_txt_track'));
  const eqProofFlowTweens = new Map();
  let eqProofFlowResizeRaf = null;

  const setupEqProofFlowText = () => {
    if (!eqProofFlowTracks.length) {
      return;
    }

    eqProofFlowTracks.forEach((track) => {
      const halfTrackWidth = track.scrollWidth / 2;
      if (!halfTrackWidth) {
        return;
      }

      const currentTween = eqProofFlowTweens.get(track);
      if (currentTween) {
        currentTween.kill();
      }

      gsap.set(track, { x: 0 });

      const nextTween = gsap.to(track, {
        x: -halfTrackWidth,
        duration: 70,
        ease: 'none',
        repeat: -1,
      });

      eqProofFlowTweens.set(track, nextTween);
    });
  };

  if (eqProofFlowTracks.length) {
    setupEqProofFlowText();

    window.addEventListener('resize', () => {
      if (eqProofFlowResizeRaf) {
        window.cancelAnimationFrame(eqProofFlowResizeRaf);
      }

      eqProofFlowResizeRaf = window.requestAnimationFrame(() => {
        setupEqProofFlowText();
        eqProofFlowResizeRaf = null;
      });
    });
  }

  const eqProofSection = document.querySelector('.is_eq-proof_sec');

  if (eqProofSection) {
    const eqProofTtl = eqProofSection.querySelector('.eq-proof_ttl');
    const eqProofTtlLines = eqProofTtl
      ? Array.from(eqProofTtl.querySelectorAll('.eq-proof_ttl_line'))
      : [];
    const eqProofLead = eqProofSection.querySelector('.eq-proof_lead_txt');
    const eqProofCharas = [
      eqProofSection.querySelector('.eq-proof_figure_chara.is_chara_01'),
      eqProofSection.querySelector('.eq-proof_figure_chara.is_chara_02'),
    ].filter(Boolean);
    const eqProofDecImages = [
      eqProofSection.querySelector('.eq-proof_dec_img.is_left'),
      eqProofSection.querySelector('.eq-proof_dec_img.is_center'),
      eqProofSection.querySelector('.eq-proof_dec_img.is_right'),
    ].filter(Boolean);

    eqProofSection.classList.add('is_anim-prep');

    if (eqProofTtlLines.length) {
      gsap.set(eqProofTtlLines, {
        y: 0,
        clipPath: 'inset(0 0 100% 0)',
      });
    } else if (eqProofTtl) {
      gsap.set(eqProofTtl, {
        y: 0,
        clipPath: 'inset(0 0 100% 0)',
      });
    }

    if (eqProofCharas.length) {
      gsap.set(eqProofCharas, { y: 22 });
    }

    if (eqProofDecImages.length) {
      gsap.set(eqProofDecImages, { y: 28 });
    }

    if (eqProofLead) {
      gsap.set(eqProofLead, { y: 24 });
    }

    const revealEqProofItem = (target, {
      start = 'top 80%',
      duration = 0.55,
      ease = 'power2.out',
      delay = 0,
    } = {}) => {
      if (!target) {
        return;
      }

      gsap.to(target, {
        autoAlpha: 1,
        y: 0,
        duration,
        ease,
        delay,
        scrollTrigger: {
          trigger: target,
          start,
          once: true,
        },
      });
    };

    if (eqProofTtlLines.length) {
      gsap.to(eqProofTtlLines, {
        autoAlpha: 1,
        clipPath: 'inset(0 0 0% 0)',
        duration: 0.95,
        stagger: 0.28,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: eqProofTtl,
          start: 'top 76%',
          once: true,
        },
      });
    } else if (eqProofTtl) {
      gsap.to(eqProofTtl, {
        autoAlpha: 1,
        clipPath: 'inset(0 0 0% 0)',
        duration: 0.95,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: eqProofTtl,
          start: 'top 76%',
          once: true,
        },
      });
    }

    eqProofCharas.forEach((chara, index) => {
      revealEqProofItem(chara, {
        start: 'top 82%',
        duration: 0.5,
        delay: index * 0.12,
        ease: 'back.out(3)',
      });
    });

    const eqProofDecImageShiftYMap = {
      is_left: 60,
      is_center: 100,
      is_right: 30,
    };

    eqProofDecImages.forEach((decImage, index) => {
      revealEqProofItem(decImage, {
        start: 'top 80%',
        duration: 0.55,
        delay: index * 0.08,
        ease: 'power2.out',
      });

      const shiftY = Object.entries(eqProofDecImageShiftYMap)
        .find(([className]) => decImage.classList.contains(className))?.[1] ?? 26;

      gsap.to(decImage, {
        y: -shiftY,
        ease: 'none',
        scrollTrigger: {
          trigger: decImage,
          start: 'top 78%',
          end: 'bottom top',
          scrub: 1.2,
        },
      });
    });

    revealEqProofItem(eqProofLead, {
      start: 'top 84%',
      duration: 0.55,
      ease: 'power2.out',
    });
  }

  const header = document.querySelector('.header');
  const triggerBtn = header?.querySelector('.trigger_btn');
  const navUnit = header?.querySelector('.nav_unit');
  let closeTimer = null;

  /*-------------------------------------------------------------------------------
    merit_list: 各 li を順番に表示するアニメーション
  --------------------------------------------------------------------------------*/
  const meritList = document.querySelector('.merit_list');
  const meritItems = meritList ? Array.from(meritList.querySelectorAll('li')) : [];

  if (meritList && meritItems.length) {
    meritList.classList.add('is_anim-prep');
    gsap.set(meritItems, { autoAlpha: 0, y: 36, scale: 0.96 });

    ScrollTrigger.create({
      trigger: meritList,
      start: 'top 75%',
      once: true,
      onEnter: () => {
        gsap.to(meritItems, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: 'back.out(1.4)',
          stagger: 0.15,
        });
      },
    });
  }

  /*-------------------------------------------------------------------------------
    thermal: 右カラムのpin止め（PCのみ）
  --------------------------------------------------------------------------------*/
  const thermalMainBlocks = Array.from(document.querySelectorAll('.thermal_main_block'));
  const thermalLeftItems = Array.from(document.querySelectorAll('.thermal_left_item'));
  const thermalSubItems = Array.from(document.querySelectorAll('.thermal_sub_list > li'));

  const ensurePinWrapper = (item, wrapperClassName) => {
    if (!item?.parentElement) {
      return null;
    }

    const currentParent = item.parentElement;
    if (currentParent.classList.contains(wrapperClassName)) {
      return currentParent;
    }

    const wrapper = document.createElement('div');
    wrapper.className = wrapperClassName;
    currentParent.insertBefore(wrapper, item);
    wrapper.appendChild(item);
    return wrapper;
  };

  if (thermalMainBlocks.length && !mobileView.matches) {
    thermalMainBlocks.forEach((thermalMainBlock) => {
      const thermalRightItem = thermalMainBlock.querySelector('.thermal_right_item');
      if (!thermalRightItem) {
        return;
      }

      ScrollTrigger.create({
        trigger: thermalMainBlock,
        start: 'top 14%',
        end: 'bottom bottom',
        pin: thermalRightItem,
        pinSpacing: false,
        invalidateOnRefresh: true,
        anticipatePin: 1,
      });
    });
  }

  if (thermalLeftItems.length && !mobileView.matches) {
    thermalLeftItems.forEach((thermalLeftItem) => {
      const hasMediaInLeftItem = !!thermalLeftItem.querySelector('.thermal_main_img, .thermal_main_movie');

      if (!hasMediaInLeftItem) {
        return;
      }

      let thermalJumpCharacter = thermalLeftItem.querySelector('.thermal_jump_character');

      if (!thermalJumpCharacter) {
        thermalJumpCharacter = document.createElement('span');
        thermalJumpCharacter.className = 'thermal_jump_character';
        thermalJumpCharacter.setAttribute('aria-hidden', 'true');
        thermalLeftItem.appendChild(thermalJumpCharacter);
      }

      ScrollTrigger.create({
        trigger: thermalLeftItem,
        start: 'top 72%',
        once: true,
        onEnter: () => {
          thermalLeftItem.classList.add('is-jump-in');
        },
      });
    });
  }

  if (thermalSubItems.length && !mobileView.matches) {
    thermalSubItems.forEach((thermalSubItem) => {
      const thermalSubLeftItem = thermalSubItem.querySelector('.thermal_sub_left_item');
      const thermalSubRightItem = thermalSubItem.querySelector('.thermal_sub_right_item');
      const thermalSubRightChildCount = thermalSubRightItem?.children?.length ?? 0;

      if (!thermalSubLeftItem || thermalSubRightChildCount <= 1) {
        return;
      }

      ScrollTrigger.create({
        trigger: thermalSubItem,
        start: 'top top',
        end: 'bottom bottom',
        pin: thermalSubLeftItem,
        pinSpacing: false,
        invalidateOnRefresh: true,
        anticipatePin: 1,
      });
    });
  }

  /*-------------------------------------------------------------------------------
    index point: 右カラムのpin止め（PCのみ）
  --------------------------------------------------------------------------------*/
  const indexPointSection = document.querySelector('.index_point_sec');
  const indexPointList = indexPointSection?.querySelector('.index_point_list');
  const indexPointItems = indexPointList ? Array.from(indexPointList.querySelectorAll('.point_num_item')) : [];
  const indexPointBlock = indexPointSection?.querySelector('.index_point_block');
  const indexPointCharaItem = indexPointSection?.querySelector('.index_common_chara_item');
  const indexPointCharaImg = indexPointCharaItem?.querySelector('.point_chara_img');
  const indexPointCharaTxt = indexPointCharaItem?.querySelector('.point_chara_txt');
  const indexPointPinDisabledView = window.matchMedia('(max-width: 768px)');

  if (indexPointSection && indexPointCharaImg && indexPointCharaTxt) {
    ScrollTrigger.create({
      trigger: indexPointSection,
      start: 'bottom 85%',
      once: true,
      onEnter: () => {
        gsap.timeline()
          .add(() => {
            indexPointCharaImg.classList.add('is_show');
          })
          .to({}, {
            duration: 0.85,
          })
          .to(indexPointCharaTxt, {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            ease: 'power2.out',
          });
      },
    });
  }

  /*-------------------------------------------------------------------------------
    top works: キャラクター表示アニメーション
  --------------------------------------------------------------------------------*/
  const firstIndexSlideSection = document.querySelector('.index_common_slide_sec');
  const indexWorksCharaItem = firstIndexSlideSection?.querySelector('.is_index_works_chara');
  const indexWorksCharaImg = indexWorksCharaItem?.querySelector('.point_chara_img');
  const indexWorksCharaTxt = indexWorksCharaItem?.querySelector('.point_chara_txt');

  if (firstIndexSlideSection && indexWorksCharaImg && indexWorksCharaTxt) {
    gsap.set(indexWorksCharaTxt, {
      autoAlpha: 0,
      y: 24,
    });

    ScrollTrigger.create({
      trigger: firstIndexSlideSection,
      start: 'top 60%',
      once: true,
      onEnter: () => {
        gsap.timeline()
          .add(() => {
            indexWorksCharaImg.classList.add('is_show');
          })
          .to({}, {
            duration: 0.85,
          })
          .to(indexWorksCharaTxt, {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            ease: 'power2.out',
          });
      },
    });
  }

  if (indexPointSection && indexPointList && indexPointBlock && !indexPointPinDisabledView.matches) {
    const indexPointPinWrapper = ensurePinWrapper(indexPointBlock, 'js-index-point-pin-wrap');

    if (indexPointPinWrapper) {
      const getIndexPointPinEndOffsetPx = () => {
        const viewportWidth = window.innerWidth;

        if (viewportWidth <= 1000) {
          return -30;
        }

        if (viewportWidth <= 1200) {
          return 70;
        }

        return 200;
      };

      const syncIndexPointPinLayout = () => {
        const listWidth = indexPointList.getBoundingClientRect().width;
        const blockWidth = indexPointBlock.getBoundingClientRect().width;
        const blockHeight = indexPointBlock.getBoundingClientRect().height;

        if (listWidth > 0) {
          indexPointList.style.width = `${listWidth}px`;
          indexPointList.style.minWidth = `${listWidth}px`;
          indexPointList.style.flex = `0 0 ${listWidth}px`;
        }

        if (blockWidth > 0) {
          indexPointPinWrapper.style.width = `${blockWidth}px`;
          indexPointPinWrapper.style.minWidth = `${blockWidth}px`;
          indexPointPinWrapper.style.flex = `0 0 ${blockWidth}px`;
          indexPointBlock.style.width = `${blockWidth}px`;
          indexPointBlock.style.minWidth = `${blockWidth}px`;
        }

        if (blockHeight > 0) {
          indexPointPinWrapper.style.height = `${blockHeight}px`;
          indexPointPinWrapper.style.minHeight = `${blockHeight}px`;
        }
      };

      syncIndexPointPinLayout();

      ScrollTrigger.create({
        trigger: indexPointList,
        start: 'top 14%',
        endTrigger: indexPointList,
        end: () => `bottom-=${getIndexPointPinEndOffsetPx()} bottom`,
        pin: indexPointPinWrapper,
        pinSpacing: false,
        invalidateOnRefresh: true,
        anticipatePin: 1,
        onRefreshInit: () => {
          syncIndexPointPinLayout();
        },
        onRefresh: () => {
          syncIndexPointPinLayout();
        },
      });
    }
  }

  /*-------------------------------------------------------------------------------
    top works: Swiper スライダー
  --------------------------------------------------------------------------------*/
  const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;

  const worksSwiperElement = document.querySelector('.js-works-swiper');
  const worksSection = worksSwiperElement?.closest('.index_common_slide_sec');
  const worksNavSelector = isMobileViewport ? '.index_works_swiper_nav.sp_only' : '.index_works_swiper_nav.pc_only';
  const worksNavElement = worksSection?.querySelector(worksNavSelector) || worksSection?.querySelector('.index_works_swiper_nav');
  const worksPrevButton = worksNavElement?.querySelector('.index_common_swiper_btn.is_prev');
  const worksNextButton = worksNavElement?.querySelector('.index_common_swiper_btn.is_next');

  if (worksSwiperElement && typeof Swiper !== 'undefined') {
    const worksSlideCount = worksSwiperElement.querySelectorAll('.swiper-slide').length;

    new Swiper(worksSwiperElement, {
      loop: worksSlideCount > 1,
      speed: 700,
      grabCursor: true,
      allowTouchMove: true,
      autoplay: {
        delay: 3600,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1.5,
      spaceBetween: 16,
      breakpoints: {
        769: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
      },
      navigation: {
        prevEl: worksPrevButton,
        nextEl: worksNextButton,
      },
    });
  }

  /*-------------------------------------------------------------------------------
    top movie: Swiper スライダー
  --------------------------------------------------------------------------------*/
  const movieSwiperElement = document.querySelector('.js-movie-swiper');
  const movieSection = movieSwiperElement?.closest('.index_common_slide_sec');
  const movieNavSelector = isMobileViewport ? '.index_movie_swiper_nav.sp_only' : '.index_movie_swiper_nav.pc_only';
  const movieNavElement = movieSection?.querySelector(movieNavSelector) || movieSection?.querySelector('.index_movie_swiper_nav');
  const moviePrevButton = movieNavElement?.querySelector('.index_common_swiper_btn.is_prev');
  const movieNextButton = movieNavElement?.querySelector('.index_common_swiper_btn.is_next');

  if (movieSwiperElement && typeof Swiper !== 'undefined') {
    const movieSlideCount = movieSwiperElement.querySelectorAll('.swiper-slide').length;

    new Swiper(movieSwiperElement, {
      loop: movieSlideCount > 1,
      speed: 700,
      grabCursor: true,
      allowTouchMove: true,
      autoplay: {
        delay: 3600,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1.5,
      spaceBetween: 16,
      breakpoints: {
        769: {
          slidesPerView: 2.8,
          spaceBetween: 24,
        },
      },
      navigation: {
        prevEl: moviePrevButton,
        nextEl: movieNextButton,
      },
    });
  }

  /*-------------------------------------------------------------------------------
    固定ヘッダー補正: ページ内リンク＆初期ハッシュ遷移
  --------------------------------------------------------------------------------*/
  const offsetAnchorId = 'js_offset_anchor';
  const mobileFixedHeaderOffset = 80;
  const thermalSectionOffsetById = {
    contents_01: {
      pc: -100,
      sp: -10,
    },
    contents_02: {
      pc: -100,
      sp: -10,
    },
    contents_03: {
      pc: -100,
      sp: -10,
    },
  };

  const getHeaderHeight = () => {
    if (mobileView.matches) {
      return mobileFixedHeaderOffset;
    }

    if (!header) {
      return 0;
    }
    return Math.ceil(header.getBoundingClientRect().height);
  };

  const scrollWithHeaderOffset = (target, {
    duration = 0.6,
    additionalOffset = 0,
  } = {}) => {
    if (!target) {
      return;
    }

    const headerHeight = getHeaderHeight();
    const baseY = target.getBoundingClientRect().top + window.pageYOffset;
    const targetY = Math.max(baseY - headerHeight + additionalOffset, 0);

    if (typeof lenis !== 'undefined' && lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(targetY, {
        duration,
        immediate: duration === 0,
        force: true,
      });
      return;
    }

    gsap.to(window, {
      duration,
      ease: 'power2.out',
      overwrite: 'auto',
      scrollTo: {
        y: targetY,
        autoKill: false,
      },
      onComplete: () => {
        const currentY = window.pageYOffset;
        if (Math.abs(currentY - targetY) > 2) {
          window.scrollTo({
            top: targetY,
            behavior: duration === 0 ? 'auto' : 'smooth',
          });
        }
      },
    });
  };

  const getHashTargetElement = (hash) => {
    if (!hash || hash === '#') {
      return null;
    }

    const id = decodeURIComponent(hash.slice(1));
    if (!id) {
      return null;
    }

    return document.getElementById(id);
  };

  const normalizePathname = (pathname = '/') => {
    if (!pathname) {
      return '/';
    }

    const normalized = pathname.replace(/\/+$/, '');
    return normalized || '/';
  };

  const getHashTargetOffset = (target) => {
    if (!target || !target.id) {
      return 0;
    }

    const sectionOffset = thermalSectionOffsetById[target.id];
    if (!sectionOffset) {
      return 0;
    }

    return mobileView.matches ? sectionOffset.sp : sectionOffset.pc;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) {
      return;
    }

    const url = new URL(link.href, window.location.href);
    const isSamePage =
      url.origin === window.location.origin
      && normalizePathname(url.pathname) === normalizePathname(window.location.pathname);
    if (!isSamePage || !url.hash) {
      return;
    }

    const target = getHashTargetElement(url.hash);
    const isThermalBtn =
      link.classList.contains('thermal_btn')
      || link.classList.contains('is-thermal')
      || !!event.target.closest('.is-thermal');
    const isOffsetAnchor = target?.id === offsetAnchorId;
    const isThermalSectionAnchor = !!(target && Object.prototype.hasOwnProperty.call(thermalSectionOffsetById, target.id));

    if (!target || (!isOffsetAnchor && !isThermalBtn && !isThermalSectionAnchor)) {
      return;
    }

    event.preventDefault();
    if (window.location.hash !== url.hash) {
      history.pushState(null, '', url.hash);
    }
    scrollWithHeaderOffset(target, {
      additionalOffset: getHashTargetOffset(target),
    });
  });

  if (window.location.hash) {
    const initialTarget = getHashTargetElement(window.location.hash);
    const isInitialOffsetAnchor = initialTarget && initialTarget.id === offsetAnchorId;
    const isInitialThermalSectionAnchor = !!(initialTarget && Object.prototype.hasOwnProperty.call(thermalSectionOffsetById, initialTarget.id));

    if (isInitialOffsetAnchor || isInitialThermalSectionAnchor) {
      window.requestAnimationFrame(() => {
        scrollWithHeaderOffset(initialTarget, {
          duration: 0,
          additionalOffset: getHashTargetOffset(initialTarget),
        });
      });
    }
  }

  document.querySelectorAll('.works_category_select').forEach((select) => {
    select.addEventListener('change', () => {
      if (select.value) {
        window.location.href = select.value;
      }
    });
  });

  if (!header || !triggerBtn || !navUnit) {
    return;
  }

  /*-------------------------------------------------------------------------------
    SP ナビゲーション開閉: メニュー動作制御
  --------------------------------------------------------------------------------*/
  const finishClose = () => {
    header.classList.remove('is-open', 'is-closing');
    document.body.classList.remove('is-nav-open');
    triggerBtn.setAttribute('aria-expanded', 'false');
  };

  const closeNav = ({ immediate = false } = {}) => {
    if (!header.classList.contains('is-open') && !header.classList.contains('is-closing')) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    header.classList.remove('is-open');
    header.classList.add('is-closing');
    document.body.classList.remove('is-nav-open');
    triggerBtn.setAttribute('aria-expanded', 'false');

    if (immediate || !mobileView.matches) {
      finishClose();
      return;
    }

    closeTimer = window.setTimeout(() => {
      finishClose();
      closeTimer = null;
    }, 980);
  };

  const openNav = () => {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    header.classList.remove('is-closing');
    header.classList.add('is-open');
    document.body.classList.add('is-nav-open');
    triggerBtn.setAttribute('aria-expanded', 'true');
  };

  const toggleNav = () => {
    if (header.classList.contains('is-closing')) {
      openNav();
      return;
    }

    if (header.classList.contains('is-open')) {
      closeNav();
      return;
    }
    openNav();
  };

  triggerBtn.setAttribute('role', 'button');
  triggerBtn.setAttribute('tabindex', '0');
  triggerBtn.setAttribute('aria-label', 'ナビゲーションを開閉');
  triggerBtn.setAttribute('aria-controls', 'global-nav');
  triggerBtn.setAttribute('aria-expanded', 'false');
  navUnit.setAttribute('id', 'global-nav');

  triggerBtn.addEventListener('click', toggleNav);
  triggerBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleNav();
    }
  });

  navUnit.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (mobileView.matches) {
        closeNav();
      }
    });
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeNav();
    }
  });

  window.addEventListener('resize', () => {
    if (!mobileView.matches) {
      closeNav({ immediate: true });
    }
  });

});

/*-------------------------------------------------------------------------------
  cmn_ttl: タイトル表示アニメーション
--------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".txt_anime");

  const wrapTextWithSpan = (node, countRef) => {
    const fragment = document.createDocumentFragment();

    if (node.nodeType === Node.TEXT_NODE) {
      [...node.textContent].forEach((char) => {
        if (char === "\n") {
          fragment.appendChild(document.createElement("br"));
        } else {
          const span = document.createElement("span");
          span.innerHTML = char === " " ? "&nbsp;" : char;
          span.style.transitionDelay = `${countRef.count * 0.05}s`;
          fragment.appendChild(span);
          countRef.count++;
        }
      });
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false); // <span> だけ複製（中身なし）
      node.childNodes.forEach((child) => {
        clone.appendChild(wrapTextWithSpan(child, countRef)); // 再帰処理
      });
      fragment.appendChild(clone);
    }

    return fragment;
  };

  targets.forEach((el) => {
    const textNodes = Array.from(el.childNodes);
    el.innerHTML = "";

    const countRef = { count: 0 };

    textNodes.forEach((node) => {
      const wrapped = wrapTextWithSpan(node, countRef);
      el.appendChild(wrapped);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  document.querySelectorAll(".txt_anime").forEach((el) => {
    observer.observe(el);
  });
});

/*-------------------------------------------------------------------------------
  スクロール: Lenis スムーススクロール制御
--------------------------------------------------------------------------------*/
const lenis = new Lenis()
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

/*-------------------------------------------------------------------------------
  TOP Validation
--------------------------------------------------------------------------------*/
if (document.body.classList.contains('contact') ) {
  topValidation();
}